import { i18nNsFactory } from '@atlas-frontend/i18n';
import { z } from 'zod/v3';
import { errorMap } from '../../common/utils';
import { ModifiedBySchema } from '../../common/utils/schema/EntitySchema';
import translations from './DataSubjectValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('data-subject-valid-form-data');
addTranslations(translations);

export const DataSubjectValidFormDataSchema = z.object({
  id: z.number().nullish(),
  comments: z.array(
    z.object({
      id: z.number().nullish(),
      comments: z
        .string(
          errorMap((issue) =>
            issue.code === z.ZodIssueCode.too_big
              ? t('validation.comments.too_big')
              : t('validation.comments.required'),
          ),
        )
        .min(1)
        .max(2000),
      createdAt: z.string().nullish(),
      createdBy: z
        .object({
          id: z.number(),
          username: z.string(),
        })
        .nullish(),
      modifiedAt: z.string().nullish(),
    }),
  ),
  createdAt: z.string().nullish(),
  createdBy: ModifiedBySchema.nullish(),
  modifiedAt: z.string().nullish(),
  modifiedBy: ModifiedBySchema.nullish(),
});
